import { render, staticRenderFns } from "./KitTimelineV2.vue?vue&type=template&id=2830308f&scoped=true&"
import script from "./KitTimelineV2.vue?vue&type=script&lang=js&"
export * from "./KitTimelineV2.vue?vue&type=script&lang=js&"
import style0 from "./KitTimelineV2.vue?vue&type=style&index=0&id=2830308f&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2830308f",
  null
  
)

export default component.exports